/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './schema.defs.js'
export * as $defs from './schema.defs.js'
